module.exports = __webpack_public_path__ + "img/amx-10.3e9f0087.webp";